import { ProgramType } from 'types';

import { QuoteSettings } from '../types/ProductionValueCheck';

import { api } from './api';

export const quotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getQuotes: build.query<any[], { id: string; programType?: ProgramType }>({
      query: ({ id, programType }) => {
        let url = '';

        switch (programType) {
          case ProgramType.hvac: {
            url = `/v2/accounts/${id}/quotes/hvac`;
            break;
          }
          case ProgramType.waterHeater: {
            url = `/v2/accounts/${id}/quotes/water-heater`;
            break;
          }
          case ProgramType.generator: {
            url = `/v2/accounts/${id}/quotes/generator`;
            break;
          }
          case ProgramType.geothermal: {
            url = `/v2/accounts/${id}/quotes/geothermal`;
            break;
          }
          case ProgramType.energyBackup: {
            url = `/v2/accounts/${id}/quotes/energy-backup`;
            break;
          }
          default:
            url = `/v3/accounts/${id}/quotes`;
            break;
        }
        return url;
      },
      providesTags: () => [{ type: 'Quotes', id: 'LIST' }],
    }),
    getQuoteSettings: build.query<QuoteSettings, { programType: ProgramType }>({
      query: ({ programType }) => ({ url: `/settings/quotes/${programType}` }),
      keepUnusedDataFor: 300,
      providesTags: () => [{ type: 'Quotes', id: 'SETTINGS' }],
    }),
    createQuote: build.mutation<any, { quoteData: any; id: string; programType?: ProgramType }>({
      query: ({ quoteData, id, programType }) => {
        let endUrl = '';
        const data = { ...quoteData };
        switch (programType) {
          case ProgramType.doePr:
            endUrl = `/v2/accounts/${id}/quotes/doe-pr`;
            data.backupBatteryManufacturer = data?.battery?.manufacturer;
            data.backupBatteryModelNumber = data?.battery?.models[0]?.modelNumber;
            data.backupBatteryQuantity = data?.battery?.models[0]?.quantity;
            delete data.battery;
            break;
          case ProgramType.hvac:
            endUrl = `/v2/accounts/${id}/quotes/hvac`;
            break;
          case ProgramType.waterHeater:
            endUrl = `/v2/accounts/${id}/quotes/water-heater`;
            break;
          case ProgramType.generator:
            endUrl = `/v2/accounts/${id}/quotes/generator`;
            break;
          case ProgramType.geothermal:
            endUrl = `/v2/accounts/${id}/quotes/geothermal`;
            break;
          case ProgramType.energyBackup:
            endUrl = `/v2/accounts/${id}/quotes/energy-backup`;
            break;
          default:
            endUrl = `/v3/accounts/${id}/quotes`;
        }
        return {
          url: endUrl,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Quotes', id: 'LIST' },
        { type: 'AccountMilestones', id },
        { type: 'Accounts', id },
        { type: 'Contracts', id: 'LIST' },
        { type: 'AccountAdders', id },
      ],
    }),
    voidQuote: build.mutation<any, { quoteId: string; accountId: string }>({
      query: ({ quoteId, accountId }) => ({ url: `/v3/accounts/${accountId}/quotes/${quoteId}`, method: 'DELETE' }),
      invalidatesTags: (_result, _error, { accountId }) => [
        { type: 'Quotes', id: 'LIST' },
        { type: 'AccountMilestones', id: accountId },
        { type: 'Accounts', id: accountId },
        { type: 'Contracts', id: 'LIST' },
      ],
    }),
  }),
});

export const { useGetQuotesQuery, useCreateQuoteMutation, useVoidQuoteMutation, useGetQuoteSettingsQuery } =
  quotesApi;
